import React from "react";
import { mapIconToDataTable as mapData } from "./Helper";
import ReusableDndTable from "src/components/table/ReusableDndTable/ReusableDndTable";
import GetIconColumns from "./ColumnDefinition/IconColumn/GetIconColumns";

const IconTable = ({ data, handleDelete, onDragEnd, status }) => {
  const columns = GetIconColumns({
    handleDelete,
    status,
  });

  return (
    <ReusableDndTable
      columns={columns}
      data={mapData(data)}
      maxHeight={450}
      onDragEnd={onDragEnd}
    />
  );
};

export default IconTable;
